var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('QuestionList',{attrs:{"edit-mode":true,"isCreate":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }